import { isMissingIndexError } from "../../../services/firestoreErrors";

export const PAGE_SIZE = 25;

export const errorText = (e, fallback = "Failed to load.") =>
  isMissingIndexError(e) ? "This view needs a Firestore index that is missing or still building." : fallback;
